export default "__VITE_ASSET__BVnr3bgS__"